// extracted by mini-css-extract-plugin
export default {"container":"Popover_container__nKpRm","content":"Popover_content__R5Mdd"};